/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { useMemo } from 'react';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { getLocaleTimeOffset } from 'ogc-processes-components';

interface Props {
  date?: string;
}
export const DateRender: React.FC<Props> = ({ date }) => {
  const { t, i18n } = useTranslation();
  const _date = useMemo(() => {
    const [offsetMinutes] = getLocaleTimeOffset();
    if (date) {
      return DateTime.fromISO(date!)
        .plus({ minute: offsetMinutes })
        .toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS, {
          locale: i18n.language ?? 'en'
        });
    }
  }, [date, i18n.language]);
  return <div>{date ? _date : t(['misc.404', 'no data available'])}</div>;
};
